module.exports = global["$"] = require("-!/home/deploy/calas-cihac/releases/20220314233228/node_modules/expose-loader/index.js?jQuery!./jquery.js");